import React from "react";
import Classnames from "classnames";
import {
  toUpperCaseFirst,
  toLowerCaseFirst,
  matchAfterUrl,
  translateAlimentLibelle,
} from "../../../../../../../ReactConst";
import _ from "lodash";
import { withTranslation } from 'react-i18next';

class Desserts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      showListAutre: false,
    };
    this.openListAutre = this.openListAutre.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeList = this.handleChangeList.bind(this);
    this.windowClick = this.windowClick.bind(this);
  }
  windowClick(event) {
    if (
      this.state.showMore &&
      !event.target.classList.contains("autre-react") &&
      !event.target.classList.contains("autre-plus")
    ) {
      this.setState({
        showListAutre: false,
        showMore: false,
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.windowClick, false);
  }
  componentDidMount() {
    if (window) {
      window.addEventListener("click", this.windowClick, false);
    }
  }
  openListAutre() {
    this.setState((prevState) => ({ showListAutre: !prevState.showListAutre }));
  }

  handleChange = (dessert) => {
    if (dessert.id === "autre-composant-repas") {
      this.setState((prevState) => ({
        showMore: !prevState.showMore,
      }));
    } else {
      let data = { id: dessert.id, name: dessert.libelle };
      this.setState({ showMore: false });
      this.props.handleChangeDesserts(data);
    }
  };
  handleChangeList = (legume) => {
    let data = { id: legume.id, name: legume.libelle };
    this.props.handleChangeDesserts(data);
  };

  render() {
    const { t } = this.props;
    if (!_.isEmpty(this.props.aliments.DESSERTS)) {
      const dessertArray = this.props.aliments.DESSERTS;
      return (
        <div className="tab-pane active" id="repas-legumes" role="tabpanel">
          <div className="row mx-n2 mb-4 d-flex align-items-center choices-objets objet-sante">
            {dessertArray.slice(0, 8).map((dessert, index) => (
              <div
                className="col-md-4 px-2"
                key={index}
                onClick={() => this.handleChange(dessert)}
              >
                <input
                  type="radio"
                  className="d-none"
                  id={dessert.id}
                  value={dessert.libelle}
                  name={dessert.libelle}
                />
                <label
                  htmlFor={dessert.libelle}
                  className={Classnames(matchAfterUrl(dessert.urlPicto), {
                    active: Array.from(this.props.recapAliments).includes(
                      dessert.libelle
                    ),
                  })}
                >
                  <span>{translateAlimentLibelle(dessert.libelle, this.props.t)}</span>
                </label>
              </div>
            ))}
            {dessertArray.length > 8 ? (
              <div className="col-md-4 px-2 autre-react">
                <input
                  type="radio"
                  className="d-none autre-react"
                  onClick={() =>
                    this.handleChange({
                      id: "autre-composant-repas",
                      name: "autre",
                    })
                  }
                  id="autre-composant-repas"
                  value="autre-composant-repas"
                  readOnly
                  checked={this.state.showMore}
                  name="legumesChoix"
                />
                <label
                  htmlFor="autre-composant-repas"
                  className={Classnames("autre-react plus-de-legumes", {
                    active: dessertArray
                      .slice(8)
                      .some((dessert) =>
                        Array.from(this.props.recapAliments).includes(
                          dessert.libelle
                        )
                      ),
                  })}
                >
                  <span className="autre-react">{t('modal_enfant.repas.other')}</span>
                </label>
              </div>
            ) : (
              ""
            )}
          </div>

          {this.state.showMore ? (
            <div className="d-flex justify-content-center mt-4">
              <div className="btn-group recap-repas dropdown autre-plus">
                <button
                  onClick={() => {
                    this.openListAutre();
                  }}
                  type="button"
                  className="custom-input box-shadow btn-show-autre-repas dropdown-toggle autre-plus"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {t('modal_enfant.repas.more_desserts')}{" "}
                </button>
                {this.state.showListAutre ? (
                  <div
                    className="dropdown-menu box-shadow autre-plus"
                    style={{ display: "block" }}
                  >
                    <ul style={{ maxHeight: "195px" }} className="autre-plus">
                      {dessertArray.slice(8).map((dessert, index) => {
                        return (
                          <li
                            className={Classnames("autre-plus", {
                              active: Array.from(
                                this.props.recapAliments
                              ).includes(dessert.libelle),
                            })}
                            key={index}
                            onClick={() => this.handleChangeList(dessert)}
                          >
                            <label
                              htmlFor={dessert.libelle}
                              className={Classnames("autre-plus", {
                                active: Array.from(
                                  this.props.recapAliments
                                ).includes(dessert.libelle),
                              })}
                              style={{ display: "inline" }}
                            >
                              <span className="autre-plus">
                                {translateAlimentLibelle(dessert.libelle, this.props.t)}
                              </span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      return "";
    }
  }
}

export default withTranslation()(Desserts);
